import { Location } from "@angular/common";
import { HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { Component, OnInit, OnDestroy } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { fadeInRightAnimation } from "src/@fury/animations/fade-in-right.animation";
import { fadeInUpAnimation } from "src/@fury/animations/fade-in-up.animation";
import { scaleInAnimation } from "src/@fury/animations/scale-in.animation";
import { ErrorType } from "src/app/enums/error-type.enum";
import { ApiService } from "src/app/services/api.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import endpoints from "src/app/helpers/endpoints";

@Component({
  selector: "fury-reduce-plan-price",
  templateUrl: "./reduce-plan-price.component.html",
  styleUrls: ["./reduce-plan-price.component.scss"],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class ReducePlanPriceComponent implements OnInit, OnDestroy {
  reducePlanPriceForm = new FormGroup({
    grossAmount: new FormGroup({
      displayMonthlyGrossPrice: new FormControl(""),
      displayYearlyGrossPrice: new FormControl(""),
      displayTwoYearlyGrossPrice: new FormControl(""),
      displayThreeYearlyGrossPrice: new FormControl(""),
      displayFourYearlyGrossPrice: new FormControl(""),
      displayFiveYearlyGrossPrice: new FormControl(""),
    }),
  });
  ngUnsubscribe = new Subject<void>();

  constructor(private apiService: ApiService, public location: Location) {}

  ngOnInit() {
    this.getCheckoutSettings();
  }

  update() {
    if (this.reducePlanPriceForm.valid) {
      this.apiService
        .post(endpoints.settings.saveGrossAmount, this.createPayload())
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe({
          next: (res: HttpResponse<any>) => {
            if (res.body) {
              this.apiService.alert(res.body.message, ErrorType.Success);
            }
          },
          error: (err: HttpErrorResponse) => {
            this.apiService.alert(err.message, ErrorType.Error);
          },
        });
    } else {
      this.reducePlanPriceForm.markAllAsTouched();
    }
  }
  createPayload() {
    const data: any = {};
    Object.keys(this.reducePlanPriceForm.value.grossAmount).forEach((item) => {
      data[item] =
        this.reducePlanPriceForm.value.grossAmount[item] &&
        this.reducePlanPriceForm.value.grossAmount[item] !== "NaN"
          ? this.reducePlanPriceForm.value.grossAmount[item]
          : 0;
    });
    return { grossAmount: data };
  }
  getCheckoutSettings() {
    this.apiService.get(endpoints.checkoutSettings.getCheckoutSettings).subscribe({
      next: (res: HttpResponse<any>) => { 
        if (res.body?.checkout_setting) {
          this.reducePlanPriceForm.patchValue({
            grossAmount: res.body.checkout_setting?.grossAmount,
          })
        }
      },
      error: (err: HttpErrorResponse) => {
        this.apiService.alert(err.message, ErrorType.Error);
      },
    });
  }
  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
